import BaseTrackingController from "../../../../../shared/src/ranj/equalture/platform/BaseTrackingController";
import InteractionEventName from "../data/InteractionEventName";

export default class TrackingController extends BaseTrackingController {

    /**
     * @param {soma.EventDispatcher} dispatcher 
     */
    constructor(dispatcher) {
        super(dispatcher);
    }

    /**
     * @param {ProgressValue} value 
     */
     trackProgress(value, elapsedTime) {
        this._dispatchProgressEvent(value, elapsedTime);
    }

    /**
     * @param {Number} puzzleIdx 
     */
    trackStartPuzzle(puzzleIdx, maxTime, minMoves, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.START_PUZZLE,
            {
                puzzle_id: this._puzzleIdFromIndex(puzzleIdx),
                minimum_moves: minMoves,
                max_time: Math.round(maxTime / 1000)
            }, 
            elapsedTime
        );
    }

    /**
     * @param {Number} puzzleIdx 
     */
    trackSolvePuzzle(puzzleIdx, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.SOLVE_PUZZLE,
            { puzzle_id: this._puzzleIdFromIndex(puzzleIdx) }, 
            elapsedTime
        );
    }

    /**
     * @param {Number} puzzleIdx 
     */
    trackFailPuzzle(puzzleIdx, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.FAIL_PUZZLE,
            { puzzle_id: this._puzzleIdFromIndex(puzzleIdx) }, 
            elapsedTime
        );
    }

    /**
     * @param {Number} puzzleIdx 
     */
    trackSkip(puzzleIdx, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.SKIP_PUZZLE,
            { puzzle_id: this._puzzleIdFromIndex(puzzleIdx) }, 
            elapsedTime
        );
    }

    /**
     * @param {Number} puzzleIdx 
     * @param {Number} moveCount 
     * @param {String} moveType - see PuzzleMove
     * @param {String} object 
     */
    trackMove(puzzleIdx, moveCount, moveType, actor = null, elapsedTime) {
        this._dispatchInteractionEvent(
            InteractionEventName.MOVE,
            {
                puzzle_id: this._puzzleIdFromIndex(puzzleIdx),
                move_nr: moveCount,
                move_action: moveType,
                move_object: actor
            },
            elapsedTime
        );
    }


    _puzzleIdFromIndex(puzzleIdx) {
        //convert index to 'id' 
        return puzzleIdx + 1;
    }
};
